import { render, staticRenderFns } from "./ReSelectCascadeObjCategory.vue?vue&type=template&id=6a590ab8&scoped=true"
import script from "./ReSelectCascadeObjCategory.vue?vue&type=script&lang=js"
export * from "./ReSelectCascadeObjCategory.vue?vue&type=script&lang=js"
import style0 from "./ReSelectCascadeObjCategory.vue?vue&type=style&index=0&id=6a590ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a590ab8",
  null
  
)

export default component.exports